import {
  CreateDTO,
  useCreateMutationFactory,
  UseCreateMutationProps,
} from '@/lib/react-query/create';
import { Inspection, InspectionLog } from '@/types';
import { post } from '@/utils/api';
import { featureKeys, featurePath, InspectionLogSearchParams } from '.';

export type CreateInspectionLogDTO = { inspection: Inspection } & CreateDTO<
  InspectionLog & { attachment?: File },
  InspectionLogSearchParams
>;

const createInspectionLog = ({ inspection, data, params = {} }: CreateInspectionLogDTO) =>
  post<InspectionLog>(`${featurePath(inspection)}`, data, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

export const useCreateInspectionLog = (options?: UseCreateMutationProps<InspectionLog>) => {
  return useCreateMutationFactory({
    invalidateKeys: featureKeys,
    mutationFn: createInspectionLog,
    ...options,
  });
};
